export type GenericIconProps = {
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
  scale?: number;
  direction?: 'top' | 'right' | 'bottom' | 'left';
};

export const directionMap = {
  top: 90,
  right: 180,
  bottom: 270,
  left: 0,
};
